import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, RouteReuseStrategy, RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { IonicRouteStrategy } from '@ionic/angular';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { ResizableModule } from 'angular-resizable-element';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';

import { DisplaySlotLocalizer } from './hgm-setup/src/module/param/services/display-slot-localizer';
import { ParamDefDisplaySlotLocalizer } from './hgm-setup/src/module/param/services/param-def-display-slot-localizer';
import { ParamAddrCalculator } from './hgm-setup/src/module/param/services/param-registry';
import { ConsoleFileLogger } from './hgm-setup/src/module/util/console-file-logger';
import { FileIo } from './hgm-setup/src/module/util/file-io';
import { FileIoReal } from './hgm-setup/src/module/util/file-io-real';
import { LOGGER } from './hgm-setup/src/module/util/logger';
import { AppParamAddrCalculator } from './providers/param-addr-calculator';
import { File } from '@ionic-native/file/ngx';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideHttpClient(),
        { provide: ParamAddrCalculator, useClass: AppParamAddrCalculator },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: DisplaySlotLocalizer,
            useClass: ParamDefDisplaySlotLocalizer,
        },
        File,
        { provide: FileIo, useClass: FileIoReal },
        {
            provide: LOGGER,
            useFactory: (cfl: ConsoleFileLogger) => cfl.logger,
            deps: [ConsoleFileLogger],
        },
        provideIonicAngular({ mode: 'md', useSetInputAPI: true }),
        provideAnimations(),
        importProvidersFrom(
            CommonModule,
            FormsModule,
            ResizableModule,
            RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
            ServiceWorkerModule.register('ngsw-worker.js', {
                enabled: environment.production,
            }),
        ),
    ],
}).catch((err) => console.log(err));
